import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import ProductComponent from './ProductComponent';
import Footer from '../LayOut/Footer';
import Header from '../LayOut/Header';
import TopNavigator from '../Extras/TopNavigator';
import { Redirect } from 'react-router-dom';

class Products extends React.Component {

	render() {
		const { history, products, category, data } = this.props;
		let categories = [];
		let value = 0;

		data.forEach((cat, index) => {
			categories.push(cat.category.name);
			if(category === cat.category.name){
				value = index
			}
		});

		const url = this.props.location.pathname.split('/')[1];
		if(this.props.data.length === 0 || url !== this.props.userName){	
			return <Redirect to={{ pathname: `/${url}` }} />;
		}

		return (
			<Fragment>
				<Header />
				<TopNavigator
					categories={categories}
					history={history}
					parent={this}
					value={value}
				/>
				<div className="col-12 col-md-3 offset-md-4">
					{/* <Link to={{ pathname: `/${pageName}/products` }} style={{ color: 'lightgray' }}>
						<IoIosArrowDropleftCircle size={30} className="ml-3 mt-4 mb-2" />
					</Link> */}
 					
					<div className="container pt-3 pl-0 pr-0" style={{ marginBottom: 90 }}>
						{products.map((item, index) => {
							return (
								<Fragment key={index}>
									<ProductComponent 
										information={item}
										category={category}
										key={item.name}
									/>
								</Fragment>
							);
						})}
					</div>
				</div>
				<Footer />
			</Fragment>
		);
	}
}

const mapStateToProps = (state) => ({
	category: state.category,
	products: state.products,
	data: state.data,
	url: state.url,
	userName: state.userName
});

export default connect(mapStateToProps)(Products);
